<template>
    <div class="d-flex flex-column flex-fill">
        <template v-for="(item, i) in items">
            <component
                v-if="item.persist || activePage.show === item.show"
                :key="'incident-item-' + i"
                v-show="activePage.show === item.show"
                :is="item.component"
                :chartParams="chartParams"
                :chartFilters="chartFilters"
                @chart="showChart"
            />
        </template>
    </div>
</template>

<script>
    import LandingPage from "./LandingPage"
    import IncidentCharting from "./IncidentCharting"

    export default {
        name: 'Incidents',

        components: {
            LandingPage,
            IncidentCharting
        },

        data() {
            return {
                activePage: {
                    name: 'Incidents',
                    show: 'index',
                    persist: true,
                    component: 'landing-page'
                },
                chartParams: {},
                chartFilters: {},
                items: [{
                    name: 'Incidents',
                    show: 'index',
                    persist: true,
                    component: 'landing-page'
                }, {
                    name: 'Incident Charting',
                    show: 'charts',
                    persist: false,
                    component: 'incident-charting'
                }]
            }
        },

        methods: {
            showChart(chartParams, chartFilters) {
                this.chartParams = chartParams
                this.chartFilters = chartFilters
                if (chartParams) {
                    let params = {chartParams, chartFilters}
                    this.$router.replace({ name: 'Incident Charting', params })
                } else {
                    this.$router.replace({ name: 'Incidents' })
                }
            }
        }
    }
</script>

<style lang="scss" scoped></style>
